import { ValidationService } from './../../../shared/services/validation.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { AppConstants } from '../../../shared/constants/constants';
import { TripInformationService } from './trip-information.service';
import { SharedService } from '../../../shared/services/share.services';
@Component({
  templateUrl: 'new-trip-information.component.html',
  providers: [TripInformationService, SharedService]
})

export class NewTripInformationPopupComponent implements OnInit {
  public appConstants = AppConstants;
  public errorPattern = {
    accomodation: 0,
    tripReason: 0,
    tripCountries: 0
  };
  public week = 1;
  public departDate = new Date();
  public returnDate = new Date(this.departDate.getTime() + (7 * 60 * 60 * 24 * 1000));
  public countriesCollection: Array<any> = [];
  public countriesOption: Array<any> = [];
  public reasons: Array<any> = [];
  public tripReasons: Array<string> = [];
  public accomodations: Array<any> = [];
  public accomodationTypes: Array<string> = [];
  public tripCountries: Array<any> = [];
  public destinationTypes: Array<any> = [];
  public iAddDefaultTripInformation: boolean = false;

  public newTripForm;
  public isDataEntryMode = false;
  constructor(private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<NewTripInformationPopupComponent>,
    public utility: Utility,
    public tripInformationService: TripInformationService,
    private sharedService: SharedService,
    @Inject(MD_DIALOG_DATA) public data: any) {
      this.isDataEntryMode = localStorage.getItem(AppConstants.localStorage.deUserId) !== 'null' ? true : false;
    this.createForm();
    // get data entry service
    this.sharedService.getDataEntryUpdate().subscribe(
      data => {
        this.updateDataEntryMode(data);
      });
  }

  ngOnInit() {
    // data return from API
    const dialogData = JSON.parse(JSON.stringify(this.data));
    this.tripReasons = dialogData.Data.tripReasons;
    this.accomodationTypes = dialogData.Data.accomodationTypes || [];
    this.destinationTypes = dialogData.Data.destinationTypes || [];

    if (dialogData.Data.departDate) {
      this.newTripForm.controls['departDate'].setValue(new Date(dialogData.Data.departDate));
    }

    if (dialogData.Data.returnDate) {
      this.newTripForm.controls['returnDate'].setValue(new Date(dialogData.Data.returnDate));
    }

    this.newTripForm.controls['week'].setValue(dialogData.Data.week);
    if (dialogData.Change === 0) {
      this.tripCountries = dialogData.Country;
      this.reasons = dialogData.Data.selectedTripReasons || [];
      this.accomodations = dialogData.Data.selectedAccomodationTypes || [];
      this.countriesOption = this.tripCountries || [];
    } else {
      if (dialogData.Country) {

        if (dialogData.Country.departDate) {
          this.newTripForm.controls['departDate'].setValue(new Date(dialogData.Country.departDate));
        }

        if (dialogData.Country.returnDate) {
          this.newTripForm.controls['returnDate'].setValue(new Date(dialogData.Country.returnDate));
        }

        this.newTripForm.controls['week'].setValue(dialogData.Country.week);
        if (dialogData.Country.tripCountries) {
          this.tripCountries = dialogData.Country.tripCountries;
          this.reasons = dialogData.Country.selectedTripReasons || [];
          this.accomodations = dialogData.Country.selectedAccomodationTypes || [];
          this.countriesOption = this.tripCountries || [];
        } else {
          this.tripCountries = dialogData.Country;
        }
      }
    }
  }

  createForm() {
    this.newTripForm = this.formBuilder.group({
      departDate: [null, [Validators.required, this.tripInformationService.validateCurrentDate(this.isDataEntryMode)]],
      returnDate: [null, [Validators.required, this.tripInformationService.validateCurrentDate(this.isDataEntryMode)]],
      week: ['1', [Validators.required, this.tripInformationService.isValidWeekNumber]]
    });
  }

  /**
  * on input depart date input event
  * @param event
  */
  onDepartDateInput(event) {
    if (!this.isValidTripDate()) {
      return;
    }
    this.tripInformationService.validateDateRange(this.newTripForm.controls['departDate'], this.newTripForm.controls['returnDate'], true);
  }

  /**
   * on change depart date input event : format the date and set
   * @param event
   */
  onDepartDateChange(event) {
    if (!this.isValidTripDate()) {
      return;
    }
    this.tripInformationService.validateDateRange(this.newTripForm.controls['departDate'], this.newTripForm.controls['returnDate'], true);
    // re-calculate week number
    const dayNum = this.calculateDateNum(this.newTripForm.controls['departDate'].value, this.newTripForm.controls['returnDate'].value);
    this.newTripForm.controls['week'].setValue(dayNum);
  }

  /**
  * on input depart date input event
  * @param event
  */
  onReturnDateInput(event) {
    if (!this.isValidTripDate()) {
      return;
    }
    this.tripInformationService.validateDateRange(this.newTripForm.controls['departDate'], this.newTripForm.controls['returnDate'], false);
  }

  /**
   * on change depart date input event : format the date and set
   * @param event
   */
  onReturnDateChange(event) {
    if (!this.isValidTripDate()) {
      return;
    }
    this.tripInformationService.validateDateRange(this.newTripForm.controls['departDate'], this.newTripForm.controls['returnDate'], false);
    // re-calculate week number
    const dayNum = this.calculateDateNum(this.newTripForm.controls['departDate'].value, this.newTripForm.controls['returnDate'].value);
    this.newTripForm.controls['week'].setValue(dayNum);
  }

  /**
   * return false if returnDate or departDate is still have error
   */
  isValidTripDate() {
    const returnDate = this.newTripForm.controls['returnDate'].errors;
    const departDate = this.newTripForm.controls['departDate'].errors;
    if ((returnDate !== null && returnDate !== undefined) || (departDate !== null && departDate !== undefined)) {
      return false;
    }
    return true;
  }

  calculateDateNum(fromDate, toDate) {
    if (fromDate === null || toDate === null) {
      return 0;
    }
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const diffDays = Math.round(Math.abs((fromDate.getTime() - toDate.getTime()) / (oneDay)));
    if (diffDays < 0) {
      return 0;
    } else {
      return Math.floor(diffDays / 7);
    }
  }

  onCloseCancel() {
    this.dialogRef.close({ data: '', action: 0 });
  }

  onChangeWeek(event) {
    if (this.tripInformationService.isValidWeekNumber(this.newTripForm.controls['week'])) {
      return;
    }
    const week = parseInt(event.target.value);
    let date = new Date(this.newTripForm.controls['departDate'].value);
    date.setDate(date.getDate() + 7 * week);
    this.newTripForm.controls['returnDate'].setValue(date);
  }

  onSaveTrips() {
    const pattern = {
      'departDate': this.newTripForm.value.departDate, // controls['departDate'] this.departDate,
      'returnDate': this.newTripForm.value.returnDate,
      'week': this.newTripForm.value.week,
      'tripCountries': this.countriesOption,
      'selectedTripReasons': this.reasons,
      'selectedAccomodationTypes': this.accomodations
    };
    if (this.isValidData(pattern) && this.newTripForm.valid) {
      this.dialogRef.close({ data: pattern, action: 1 });
      // this.dialogRef.close({ data: '', action: 0 });
    }


    // console.log('pattern', pattern);
    // const validate = this.validateData(pattern);
    // console.log(validate);

    // this.dialogRef.close({ data: pattern, action: 1 });
  }

  onSelectOption(country, item) {
    // if (this.countriesOption) {
    const index = this.countriesOption.findIndex(t => t.id === country.id);
    if (index !== -1) {
      this.countriesOption[index].destinationTypeId = item;
    } else {
      const temp = country;
      temp['destinationTypeId'] = item;
      this.countriesOption.push(temp);
    }
    // }
  }

  onCheckReason(item) {
    const index = this.reasons.findIndex(t => t === item);
    if (index !== -1) {
      this.reasons.splice(index, 1);
    } else {
      this.reasons.push(item);
    }
    // update errorPattern
    this.errorPattern.tripReason = (this.reasons.length <= 0) ? 1 : 0;
  }

  onCheckAccomodation(item) {
    const index = this.accomodations.findIndex(t => t === item);
    if (index !== -1) {
      this.accomodations.splice(index, 1);
    } else {
      this.accomodations.push(item);
    }
    // update errorPattern
    this.errorPattern.accomodation = (this.accomodations.length <= 0) ? 1 : 0;
  }

  onClickAddDefaultTripInformation(iAddDefaultTripInformation){
    this.iAddDefaultTripInformation = !iAddDefaultTripInformation;

    if(this.iAddDefaultTripInformation)
    {let date = new Date();
      this.newTripForm.controls['returnDate'].setValue(date);
      this.newTripForm.controls['departDate'].setValue(date);

      this.reasons = [];
      this.reasons.push("Other");

      this.accomodations = [];
      this.accomodations.push("Other");

      var defaultCountry = {
        id : "b974887f-d908-ea11-b628-10e7c6ab93c2",
        isoCode: "IE",
        name: "IRELAND",
        destinationTypeId: "237a887f-d908-ea11-b628-10e7c6ab93c2",
        countryRegions: []
      };

      this.tripCountries = [];
      this.tripCountries.push(defaultCountry);

      this.countriesOption = [];
      this.countriesOption.push(defaultCountry);
    }
  }

  mapReasons(item) {
    let flag = false;
    if (this.reasons) {
      if (this.reasons.findIndex(t => t === item) !== -1) {
        flag = true;
      } else {
        flag = false;
      }
    }
    return flag;
  }

  mapAccomodations(item) {
    let flag = false;
    if (this.accomodations) {
      if (this.accomodations.findIndex(t => t === item) !== -1) {
        flag = true;
      } else {
        flag = false;
      }
    }
    return flag;
  }

  mapDestinations(country, item) {
    let flag = false;
    if (item === country.destinationTypeId) {
      flag = true;
    } else {
      flag = false;
    }
    return flag;
  }

  isValidData(data) {
    this.errorPattern.accomodation = (data.selectedAccomodationTypes.length <= 0) ? 1 : 0;
    this.errorPattern.tripReason = (data.selectedTripReasons.length <= 0) ? 1 : 0;
    this.errorPattern.tripCountries = 0;
    data.tripCountries.forEach(element => {
      if (!('destinationTypeId' in element)) {
        this.errorPattern.tripCountries = 1;
      }
    });

    if (this.errorPattern.accomodation === 1 || this.errorPattern.tripReason === 1 ||
      this.errorPattern.tripCountries === 1) {
      return false;
    }
    return true;
  }
  /**
   * update isDataEntryMode flag
   * @param dataEntryMode : 0/1
   */
  updateDataEntryMode(dataEntryMode) {
    this.isDataEntryMode = (dataEntryMode === 1) ? true : false;
  }
  
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/trip-information/new-trip-information.component.ts